import { ADD_SERIES, DELETE_SERIES, GET_SERIES, UPDATE_SERIES, GET_ONE_SERIES } from '../types';

const initialState = { list: [], single: null, pagination: null, loading: false, error: null, single: null };

const reducer = (state = initialState, action) => {
   const { type, payload } = action;

   switch (type) {
      case GET_SERIES:
         return {
            ...state,
            list: action.payload.data,
            pagination: action.payload.pagination, // Make sure this matches your API response
            loading: false,
            error: null,
         };

      case UPDATE_SERIES:
         return {
            ...state,
            list: state.list.map((item) => (item.id === payload.id ? payload : item)),
         };

      case ADD_SERIES:
         return {
            ...state,
            list: [payload, ...state.list],
         };

      case DELETE_SERIES:
         return {
            ...state,
            list: state.list.filter((item) => item.id !== payload.id),
         };

      case GET_ONE_SERIES:
         return { ...state, single: payload };

      default:
         return state;
   }
};

export default reducer;
